<template functional>
    <table border="1" class="mdtable" width="100%">
        <thead>
            <tr>
                <th>기능</th>
                <th width="*">문법 or 예제</th>
                <th>HTML &amp; Link</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <th>제목 지정</th>
                <td># 제목 1<br> ## 제목 2<br> ### 제목 3<br> #### 제목 4<br> ##### 제목 5<br> ###### 제목 6</td>
                <td>h1~h6 태그</td>
            </tr>
            <tr>
                <th>굵은 글씨</th>
                <td>**굵게**<br>__굵게__</td>
                <td>strong, b 태그</td>
            </tr>
            <tr>
                <th>기울린 글씨</th>
                <td>*기울림*<br>_기울림_</td>
                <td>em, i 태그</td>
            </tr>
            <tr>
                <th>취소선</th>
                <td>~~취소선~~</td>
                <td>strike, del 태그</td>
            </tr>
            <tr>
                <th>인용구</th>
                <td>> 인용구</td>
                <td>blockquote 태그</td>
            </tr>
            <tr>
                <th>수평선</th>
                <td>***<br>---</td>
                <td>hr 태그</td>
            </tr>
            <tr>
                <th>링크 걸기</th>
                <td>[글자](링크주소)</td>
                <td>a 태그</td>
            </tr>
            <tr>
                <th>이미지 삽입</th>
                <td>![설명](이미지주소)</td>
                <td>img 태그</td>
            </tr>
            <tr>
                <th>순서 없는 목록</th>
                <td>* 목록1<br>* 목록2<br>(줄 맨 앞에 *, -, + 기호 사용)</td>
                <td>ul, li 태그</td>
            </tr>
            <tr>
                <th>순서 있는 목록</th>
                <td>1. 목록1<br>1. 목록2<br>(줄 맨 앞에 (숫자). 사용)</td>
                <td>ol, li 태그</td>
            </tr>
            <tr>
                <th>할일(체크) 목록</th>
                <td>- [x] 체크됨 <br>- [ ] 체크안됨</td>
                <td>-</td>
            </tr>
            <tr>
                <th>코드 강조</th>
                <td>`강조할 코드`</td>
                <td>pre, code 태그</td>
            </tr>
            <tr>
                <th>프로그래밍 구문 강조</th>
                <td>```[언어]<br>(내용)<br>```</td>
                <td>pre, code 태그</td>
            </tr>
            <tr>
                <th>이모지</th>
                <td>:(이모지명):</td>
                <td>
                    <a target="_blank" href="https://www.webfx.com/tools/emoji-cheat-sheet/">목록</a>
                    | <a target="_blank" href="https://emojipedia.org/">참고</a>
                </td>
            </tr>
            <tr>
                <th>뱃지</th>
                <td>![설명](https://img.shields.io/badge/(라벨)-(메세지)-(색상))</td>
                <td><a target="_blank" href="https://shields.io/">참고</a></td>
            </tr>
        </tbody>
    </table>
</template>

<script>
export default {

}
</script>

<style>
.mdtable {
    border: 1px solid #777;
    border-collapse: collapse;
}
.mdtable th, .mdtable td {
    padding: 4px;
}
.mdtable tr:nth-child(even){
    background-color: #e7e7e7;
}
.mdtable tr:hover {
    background-color: #f7f7f7;
}
</style>